module.exports = __webpack_public_path__ + "images/BioXcel-62345b.png";